export default __webpack_public_path__ + "static/media/13.d6bc717f.svg";